import { CognitoUserPool } from 'amazon-cognito-identity-js';

const MONITORS_POOL_CONFIG = {
  UserPoolId: 'us-east-1_M7iwy7ljw',
  ClientId: '4lcva2l5avqvthurk669ete40q',
};

export const monitorUserPool = new CognitoUserPool(MONITORS_POOL_CONFIG);
